import { JointEntityShape } from '../Shape/JointEntityShape';
import { JointInterfaceShape } from '../Shape/JointInterfaceShape';
import { EntityGeneration } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EntityGeneration';
import { InterfaceGeneration } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/InterfaceGeneration';
import { RelationshipLink } from '../../BaseShape/RelationshipLink';
import { Generation } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Generation';
import { MDAConstant } from '../../Base/MDAConstant';
import { MDRepository } from '../../../MD/MDRepository';

export class JointGenerationLink extends RelationshipLink {
  constructor(opt?: any) {
    super(opt);
    this.set('type', 'mst.JointGenerationLink');
    this.attr({
      // '.connection': { stroke: 'lime' },
      // '.marker-target': { d: 'M 10 0 L 0 5 L 10 10 z', fill: 'lime', stroke: 'lime' },
      // '.marker-arrowhead': { d: 'M 10 0 L 0 5 L 10 10 z' },
      // '.marker-arrowhead-group-source .marker-arrowhead': { d: 'M 0 0 L 10 0 L 10 10 L 0 10 z', fill: 'lime' },
      line: { stroke: 'lime' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (opt) {
      this.setMD(opt?.shape, opt?.model, true);
    }
  }

  changeTarget(source: joint.dia.Element, target: joint.dia.Element) {
    console.log('changeTarget');
    // target, source 必须同时是实体或接口
    if (target instanceof JointEntityShape && source instanceof JointEntityShape) {
      const sourceEntity = source.entity;
      const targetEntity = target.entity;
      let relationship = this.element() as EntityGeneration;
      if (relationship === null) {
        relationship = MDRepository.createEntityGeneration(null, targetEntity, sourceEntity, false);
      }
      relationship.name = `${sourceEntity.name}_generalize_${targetEntity.name}`;
      relationship.displayName = `${sourceEntity.displayName}_继承于_${targetEntity.displayName}`;
      relationship.description = relationship.displayName;
      relationship.superEntity = targetEntity;
      sourceEntity.superEntity = targetEntity;
      this.setModel(relationship);
      // sourceEntity.subGenerations.push(relationship);
      // targetEntity.superGenerations.push(relationship);
      return relationship;
    } else if (target instanceof JointInterfaceShape && source instanceof JointInterfaceShape) {
      const sourceInterface = source.interface;
      const targetInterface = target.interface;
      let relationship = this.element() as InterfaceGeneration;
      if (relationship === null) {
        relationship = MDRepository.createInterfaceGeneration(null, targetInterface, sourceInterface, false);
      }
      relationship.name = `${sourceInterface.name}_generalize_${targetInterface.name}`;
      relationship.displayName = `${sourceInterface.displayName}_继承于_${targetInterface.displayName}`;
      relationship.description = relationship.displayName;
      relationship.superInterface = targetInterface;
      this.setModel(relationship);
      // sourceInterface.subGenerations.push(relationship);
      // targetInterface.superGenerations.push(relationship);
      return relationship;
    }
    return null;
  }

  get generation(): Generation {
    return this.element() as Generation;
  }

  public shapeType(): string {
    return MDAConstant.Link.ADD_GENERALIZATION;
  }

  /**
   * 检查源和目标类型对当前关系是否有效
   * 继承关系：用于实体与实体、接口与接口
   * @param sourceType 源类型
   * @param targetType 目标类型
   * @returns 有效返回true
   */
  public checkShapeType(sourceType: string, targetType: string): boolean {
    if (sourceType === MDAConstant.Type.ADD_ENTITY && targetType === MDAConstant.Type.ADD_ENTITY) {
      return true;
    }
    return false;
  }
}
